import React, { useMemo } from "react";
import axios from "axios";
import store from "../redux/store";
import { useDispatch } from "react-redux";
import { signOut } from "../redux/slices/userSlice";
import { Menu, Button } from "antd";
import baseOC from "icfrontendbase";
import "../styles/topbar.css";

function TopBar() {
    const dispatch = useDispatch();

    const handleSignout = async () => {
        try {
         await axios.post("/auditor/business/account/signout");
        } catch(error) {
            
        }
        // wait for signout to complete before redirect
        store.dispatch(
            signOut() 
      
        );
    }

    const cisobotLogoUrl = useMemo(() => {
        const imageUrlProcurer = baseOC.get("ImageUrlProcurer")
        return imageUrlProcurer.procure("cb_logo");
    }, [])

    return (
        <>
            <div>
                <img src={cisobotLogoUrl} alt="CISOBot" />
                <Menu
                    theme="light"
                    mode="horizontal"
                    defaultSelectedKeys={["1"]}
                    // future note, when the selection changes, the callback to handle the page change should use navigate()
                    items={[
                        {
                            key: "1",
                            label: `Dashboard`,
                        },
                        // {
                        //     key: "2",
                        //     label: `Account`,
                        // },
                        // {
                        //     key: "3",
                        //     label: `Settings`,
                        // }
                    ]}
                />
            </div>
            <Button onClick={handleSignout}>
                <i className="fas fa-sign-out-alt" />
                Sign Out
            </Button>
        </>
    )
}

export default TopBar;
